export default __webpack_public_path__ + "static/media/genji-justlogo.8cf30e27.png";